import React from "react";
import { GoogleMapsContext } from "./GoogleMapsContext.js";

export function useGoogleMapsApi() {
  const { isLoaded } = React.useContext(GoogleMapsContext);

  return { isLoaded };
}
